import { useQuery } from '@tanstack/react-query';
import { gameQueryOptions } from '@/queries/games/games.queries';
import { useAppSelector } from '@/redux/hooks';

export const useIsGameFavorites = (gameId: string) => {
  const userSession = useAppSelector(state => state.user.userSession);

  const { data: favoriteGames } = useQuery(
    gameQueryOptions.favoritesList({ params: { limit: 50 }, options: { enabled: !!userSession } }),
  );

  const isGameFavorites = (id: string): boolean => {
    if (!favoriteGames?.items) {
      return false;
    }
    return favoriteGames.items.some(favGame => favGame.id === id);
  };

  const isInternalFavorite = userSession ? isGameFavorites(gameId) : false;
  const favoritesTotalItems = favoriteGames?.totalItems ?? 0;

  return { isInternalFavorite, userSession, favoritesTotalItems };
};
